

<app-page-loader></app-page-loader>
<app-alert-toaster></app-alert-toaster>
<app-idle-warning-modal></app-idle-warning-modal>

<router-outlet></router-outlet>



